import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const fieldLabel = "block text-xs font-medium uppercase tracking-[0.08em] text-zinc-400 dark:text-zinc-500 mb-1";
const textarea = "w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-zinc-900 placeholder-zinc-400 focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-400/30 dark:border-white/[0.08] dark:bg-white/[0.05] dark:text-zinc-100";

export default function GigCreationForm({
  gigForm,
  isCreatingGig,
  editingGig,
  onSubmit,
  onFieldChange,
  onCancelEdit,
}) {
  const isEditing = Boolean(editingGig);
  return (
    <section id="gig-form-section" className="panel p-6">
      <h2 className="text-lg font-bold tracking-tight text-zinc-900 dark:text-zinc-50">
        {isEditing ? "Edit gig" : "Share a new gig"}
      </h2>
      <p className="mt-1 text-sm text-zinc-500 dark:text-zinc-400">
        {isEditing
          ? "Update the details below and save your changes."
          : "Artists will see your opportunity immediately after you publish it."}
      </p>
      <form className="mt-5 grid gap-4 md:grid-cols-2" onSubmit={onSubmit}>
        <div className="md:col-span-2">
          <label className={fieldLabel} htmlFor="gig-title">Gig title</label>
          <Input
            id="gig-title"
            value={gigForm.title}
            onChange={onFieldChange("title")}
            placeholder="Late night house band"
            required
          />
        </div>
        <div>
          <label className={fieldLabel} htmlFor="gig-date">Date &amp; time</label>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Input
              id="gig-date"
              type="date"
              value={gigForm.date}
              onChange={onFieldChange("date")}
              required
            />
            <Input
              id="gig-time"
              type="text"
              inputMode="numeric"
              maxLength={5}
              placeholder="hh:mm"
              value={gigForm.time}
              onChange={onFieldChange("time")}
              required
            />
          </div>
        </div>
        <div>
          <label className={fieldLabel} htmlFor="gig-city">City</label>
          <Input
            id="gig-city"
            value={gigForm.city}
            onChange={onFieldChange("city")}
            placeholder="Copenhagen"
          />
        </div>
        <div>
          <label className={fieldLabel} htmlFor="gig-payout">Estimated payout (DKK)</label>
          <Input
            id="gig-payout"
            type="number"
            min="0"
            value={gigForm.payout}
            onChange={onFieldChange("payout")}
            placeholder="2500"
          />
        </div>
        <div>
          <label className={fieldLabel} htmlFor="gig-genres">Preferred genres</label>
          <Input
            id="gig-genres"
            value={gigForm.genres}
            onChange={onFieldChange("genres")}
            placeholder="Jazz, Soul"
          />
        </div>
        <div className="md:col-span-2">
          <label className={fieldLabel} htmlFor="gig-description">Description</label>
          <textarea
            id="gig-description"
            value={gigForm.description}
            onChange={onFieldChange("description")}
            rows={3}
            className={textarea}
            placeholder="Tell artists about the gig, set length, audience, tech notes..."
          />
        </div>
        <div>
          <label className={fieldLabel} htmlFor="gig-tags">Tags</label>
          <Input
            id="gig-tags"
            value={gigForm.tags}
            onChange={onFieldChange("tags")}
            placeholder="Festival, Outdoor"
          />
        </div>
        <div className="md:col-span-2 flex items-center gap-3">
          <Button type="submit" className="btn-primary" disabled={isCreatingGig}>
            {isCreatingGig
              ? (isEditing ? "Saving..." : "Publishing...")
              : (isEditing ? "Save changes" : "Publish gig")}
          </Button>
          {isEditing && (
            <Button type="button" className="btn-secondary" onClick={onCancelEdit}>
              Cancel
            </Button>
          )}
        </div>
      </form>
    </section>
  );
}
